import React from 'react';
import { Search } from '@emorg-prd/standard-react';
import './Searchbar.css'

type SmallSizeClass = 'em-c-search-form--small' | undefined;

interface SearchbarProps extends React.ComponentProps<typeof Search> {
	condensed?: boolean;
	placeholder?: string;
	className?: string;
	smallHeight?: string;
}

export const Searchbar: React.FC<SearchbarProps> = (props) => {
	const size: SmallSizeClass = props.condensed ? 'em-c-search-form--small' : undefined;

	return <Search {...props} size={size} optionalClass={props.className} />;
};
